export default function Cards(props) {
  return (
    <svg
      id="Component_30_3"
      data-name="Component 30 – 3"
      xmlns="http://www.w3.org/2000/svg"
      width="27.192"
      height="20"
      viewBox="0 0 27.192 20"
      {...props}>
      <path
        id="Path_5766"
        data-name="Path 5766"
        d="M-452.445-135.191a1.8,1.8,0,0,1-1.317,1.847c-3.192.865-6.388,1.713-9.594,2.525a1.592,1.592,0,0,1-1.958-1.222q-1.914-6.967-3.774-13.95a1.662,1.662,0,0,1,1.212-2.142q4.729-1.334,9.485-2.57c1.069-.277,1.919.377,2.256,1.622q1.777,6.564,3.537,13.134C-452.525-135.675-452.485-135.393-452.445-135.191Zm-9.341-9.451c-.557.715-1.1,1.33-1.545,2.009a6.635,6.635,0,0,0-.969,1.91,2.134,2.134,0,0,0,2.608,2.6,6.455,6.455,0,0,0,1.128-.5l-.1,1.93,1.762-.489-.993-1.6a7.066,7.066,0,0,0,1.3-.19,2.047,2.047,0,0,0,1.415-1.735,2.112,2.112,0,0,0-1.074-2.249C-459.387-143.6-460.613-144.089-461.786-144.642Z"
        transform="translate(469.16 150.767)"
        fill="#f7f7f7"
      />
      <path
        id="Path_5767"
        data-name="Path 5767"
        d="M-431.081-132.314c2.231-1.041,2.572-1.791,1.978-4.02q-1.494-5.61-2.97-11.224c-.53-2.017.826-3.412,2.805-2.885q4.288,1.143,8.569,2.317a1.83,1.83,0,0,1,1.5,2.607q-1.728,6.572-3.474,13.139c-.4,1.492-1.173,1.943-2.657,1.562C-427.207-131.3-429.083-131.794-431.081-132.314Z"
        transform="translate(446.259 150.636)"
        fill="#f7f7f7"
      />
    </svg>
  );
}
